<template>
  <div class="ts-space-y-3">
    <div class="ts-grid ts-grid-cols-3 ts-gap-2">
      <label class="ts-my-auto required">{{ $t('tableBooking.bookingDate') }}</label>
      <div class="ts-col-span-2">
        <a-date-picker
					disabled
          class="ts-w-full"
          :allowClear="false"
          v-model="model.booking_date"
          format="DD-MM-YYYY"
          valueFormat="DD-MM-YYYY"
        />
				<div class="validate" v-if="errors.has('booking_date')">
					{{ errors.first('booking_date') }}
				</div>
      </div>
      <label class="ts-my-auto required">{{ $t('tableBooking.customerName') }}</label>
      <div class="ts-col-span-2">
        <a-auto-complete
          class="ts-w-full"
          v-model="model.customer_name"
          :data-source="customerResource"
          @select="onSelect"
          @change="onChange"
        />
				<div class="validate" v-if="errors.has('customer_name')">
					{{ errors.first('customer_name') }}
				</div>
      </div>
      <label class="ts-my-auto required">{{ $t('tableBooking.phoneNumber') }}</label>
      <div class="ts-col-span-2">
        <a-input type="text" v-model="model.phone_number">
          <a-tooltip slot="suffix">
            <a-icon type="phone" />
          </a-tooltip>
        </a-input>
				<div class="validate" v-if="errors.has('phone_number')">
					{{ errors.first('phone_number') }}
				</div>				
      </div>
      <label class="required">{{ $t('tableBooking.time') }}</label>
      <div class="ts-col-span-2">
        <a-select
          v-model="model.time_schedule"
          :options="timeList"
          showSearch
          :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
          mode="multiple"
          class="ts-w-full"
        />
				<div class="validate" v-if="errors.has('time_schedule')">
					{{ errors.first('time_schedule') }}
				</div>		
      </div>
      <label class="ts-my-auto">{{ $t('tableBooking.numberPerson') }}</label>
      <div class="ts-col-span-2">
        <a-input type="number" v-model.number="model.num_person">
          <a-tooltip slot="suffix">
            <a-icon type="user" />
          </a-tooltip>
        </a-input>
				<div class="validate" v-if="errors.has('num_person')">
					{{ errors.first('num_person') }}
				</div>
      </div>
      <label class="ts-my-auto">{{ $t('tableBooking.purpose') }}</label>
      <div class="ts-col-span-2">
        <a-input type="text" v-model.trim="model.purpose" />
				<div class="validate" v-if="errors.has('purpose')">
					{{ errors.first('purpose') }}
				</div>
      </div>
      <label class="ts-my-auto">{{ $t('tableBooking.companyName') }}</label>
      <div class="ts-col-span-2">
        <a-input type="text" v-model.trim="model.company_name" />
				<div class="validate" v-if="errors.has('company_name')">
					{{ errors.first('company_name') }}
				</div>
      </div>
      <label>{{ $t('tableBooking.description') }}</label>
      <div class="ts-col-span-2">
        <textarea v-model.trim="model.description" rows="5" class="form-control"></textarea>
				<div class="validate" v-if="errors.has('description')">
					{{ errors.first('description') }}
				</div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 ts-space-x-2 ts-text-right">
        <ts-button @click.prevent="$emit('cancel')">{{ $t('cancel') }}</ts-button>
        <ts-button color="primary" :waiting="waiting" @click.prevent="onSave">{{ $t('save') }}</ts-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  props: ['table'],
  data() {
    return {
			waiting: false,
			errors: new Errors(),
      model: {
        booking_ref_id: 0,
        booking_date: null,
				customer_name: '',
				company_name: null,
        customer_id: null,
        phone_number: null,
        table_id: null,
        time_schedule: [],
        num_person: null,
        purpose: null,
        description: null
      }
    }
  },
  created() {
    this.createTimeRow()
  },
  computed: {
    ...mapGetters('booking/tableBooking', ['getDescription', 'getBookingId', 'getRef', 'customerBooking']),
    ...mapState('booking/tableBooking', [
      'schedules',
      'bookingDate',
      'customers'
    ]),
    customerResource() {
      return this.customers
        .filter(
          c =>
            c.customer_name
              .toLowerCase()
              .indexOf(this.model.customer_name.toLowerCase()) != -1
        )
        .map(el => el.customer_name + '|' + el.contact_number)
    },
    timeList() {
      return this.schedules.map(el => ({
        value: el.schedule_id,
        label: el.schedule_time
      }))
    }
  },
  methods: {
    ...mapActions('booking/tableBooking', ['store', 'fetch']),
    onSave() {
      this.waiting = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetch().finally(() => {
            this.$emit('cancel')
            this.waiting = false
          })
        })
        .catch(error => {
					this.$toasted.error(error.message)
					this.errors = new Errors(error.errors)
					this.waiting = false
        })
    },
    createTimeRow() {
      this.model.booking_ref_id = this.getRef({ 
        tableId: this.table.table_id, 
        scheduleId: this.table.schedule_id
      })
      this.model.table_id = this.table.table_id
      this.model.booking_date = this.bookingDate
      
      var book = this.customerBooking({
        tableId: this.table.table_id, 
        referenceId: this.model.booking_ref_id
      })

      if(book.length > 0){
        this.model.customer_name = book[0].customer ? book[0].customer.customer_name : null
				this.model.company_name = book[0].customer ? book[0].customer.company_name : null
        this.model.customer_id = book[0].customer_id
        this.model.phone_number = book[0].customer ? book[0].customer.contact_number : null
        this.model.num_person = book[0].num_person
        this.model.purpose = book[0].purpose
        this.model.description = book[0].description
        this.model.time_schedule = []
        book.forEach(el => {
         this.model.time_schedule.push(el.schedule_id)
        });
      }else {
        this.model.time_schedule.push(this.table.schedule_id)
      }
    },
    onSelect(value) {
      var phone = _.last(_.split(value, '|'))
      if (phone != null || phone != 'null') {
				this.model.phone_number = phone
        let filter  = this.customers
          .filter(c => c.contact_number == phone)
					.reduce((init, value) => (init = value), null)
				this.model.customer_id = filter.customer_id
				this.model.company_name = filter.company_name
      }
    },
    onChange(value) {
			this.model.customer_id = null
			this.model.phone_number = null
    }
  }
}
</script>